
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import DepartmentRecord from './DepartmentRecord';

@Component
export default class EditableCellTitle extends Vue {
  $refs!: {
    theinput: any;
  };

  @Prop()
  record!: DepartmentRecord;

  valueChanged: number = 0;
  newValue!: string;
  editmode: boolean = false;

  mounted() {
    if (this.record && this.record.rowEdit && this.record.newRowRecord) {
      this.$refs.theinput.focus();
    }
  }
  get NewRowRecord() {
    if (this.record) {
      return this.record.newRowRecord;
    }
    return false;
  }

  get editvalue() {
    this.valueChanged;
    if (this.newValue) {
      return this.newValue;
    } else if (this.record) {
      return this.record.department.title;
    } else return "";
  }

  change(e: any) {
    this.newValue = e.srcElement.value;
    if (this.record.newRowRecord) {
      this.$emit("update", this.newValue);
    }
  }

  editToggle() {
    this.editmode = !this.editmode;
    if (this.editmode) {
      this.$nextTick(() => this.$refs.theinput.focus());
    }
  }

  cancelEdit() {
    delete this.newValue;
    this.editmode = !this.editmode;
    this.valueChanged++;
  }

  acceptEdit() {
    this.editmode = !this.editmode;
    this.valueChanged++;
    if (this.newValue) {
      this.$emit("update", this.newValue);
    }
  }
}
